
import UiHelper                 from '_utils/UiHelper';

let navigation,
    mobileNavbarControls,
    navbarOptionsWithDropdown,
    navbarOptionsWithLingerEvents,
    talkToUsCta,
    landingPage,
    landingPreviewPage;

const navbar = {

  init() {

    /*
    ==================================================
     CACHE DOM ELEMENTS
    ==================================================
    */

    navigation = document.querySelector('.navbar');
    landingPage = document.querySelector('.landing-page');
    landingPreviewPage = document.querySelector('.landing-preview-page');

    if (navigation) {
      mobileNavbarControls = navigation.querySelectorAll('.mobile-control');
      navbarOptionsWithDropdown = navigation.querySelectorAll('.navbar-link.dropdown');
      navbarOptionsWithLingerEvents = navigation.querySelectorAll('.navbar-list.links .lingerable');
      talkToUsCta = navigation.querySelector('.navbar-list.buttons .talk-to-us');
    }

    if (landingPage) {
      this.handleNavbarColorMode(); // NOTE: methods with the prefix "handle" are event handlers. This should be named manageColorMode or similar and placed under "LOCAL UTILS"
      this.handleDarkNavbarBorder(); // NOTE: same as above
    }

    // Remove this after the preview page is no longer needed
    if (landingPreviewPage) {
      this.handleNavbarColorMode();
      this.handleDarkNavbarBorder();
    }

    if (mobileNavbarControls) {
      // NOTE: place the below into its own method called 'wireMobileNavbarControls' or similar. Also, for every "wire" or "startMonitor" method, there should be a corresponding "clear" or "stopMonitor" method to remove the event listeners (if possible)
      mobileNavbarControls.forEach(mobileNavControl => {
        mobileNavControl.addEventListener('click', (e) => {
          this.handleMobileNavbarControlsClick(e, mobileNavControl);
        });
      });
    }

    if (navbarOptionsWithDropdown) {
      // NOTE: place the below into its own method called 'wireDropdownOptions' or similar
      navbarOptionsWithDropdown.forEach(navbarOptionWithDropdown => {
        navbarOptionWithDropdown.addEventListener('click', (e) => {
          this.handleExpandDropdownClick(e, navbarOptionWithDropdown);
        });
      });
    }

    if (navbarOptionsWithLingerEvents) {
      navbarOptionsWithLingerEvents.forEach(navbarOptionWithLingerEvent => {
        // NOTE: place the below into its own method called 'wireLingerOptions' or similar
        UiHelper.onLinger(navbarOptionWithLingerEvent, (e) => {

          if (navigation.classList.contains('is-open')) {
            return;
          }

          this.handleNavbarLinkOnLinger(e, navbarOptionWithLingerEvent);
        });
      });
    }

    if (talkToUsCta) {
      this.handleAddTalkToUsCta();
    }
  },


  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */

  // All methods in each section of our JS files should be alphabetized.


  // NOTE: We use the prefix "on" when passing a reference to a "handler" function, and "handle" when defining the function itself. Handlers should be named using the following convention: 'handle[specifier][event]()'This should be called "handleDropdownLinger" or similar
  handleExpandDropdownOnLinger(e, elem) {
    e.stopPropagation();

    this.closeOtherDropdownMenus(elem);
    this.isDropdownMenuOpen(elem) ? this.closeDropdownMenu(elem) : this.openDropdownMenu(elem);
  },

  handleExpandDropdownClick(e, elem) {
    e.stopPropagation();

    this.closeOtherDropdownMenus(elem);
    this.isDropdownMenuOpen(elem) ? this.closeDropdownMenu(elem) : this.openDropdownMenu(elem);
  },

  handleMobileNavbarControlsClick(e, elem) {
    e.preventDefault();
    e.stopPropagation();

    const isMobileGenomeOpen = false;
    const isMobileMenuOpen = navigation.classList.contains('menu');

    if (elem.classList.contains('search-icon')) {
      if (isMobileMenuOpen) {
        this.closeMobileMenu();
        navigation.querySelector('.hamburger-icon').classList.remove('is-active')
      }
    } else if (elem.classList.contains('hamburger-icon')) {
      if (isMobileMenuOpen) {
        this.closeMobileMenu();
        elem.classList.remove('is-active')
      } else {
        this.openMobileMenu();
        elem.classList.add('is-active')
      }
    }
  },

  // NOTE: This is not a true handler. What is the event? "Mode"? This should be named "manageColorMode" or "wireBand1" or similar
  handleNavbarColorMode() {
    const firstBand = document.querySelector('.band-1');

    const observer = new IntersectionObserver(
      ([entry]) => {
        // NOTE: This code here is a candidate for a handler of the "isIntersecting" event. It *could* be named "handleBand1Intersection" or similar
        if (entry.isIntersecting) {
          navigation.classList.add("dark-mode");
        } else {
          navigation.classList.remove("dark-mode");
        }
      },
    );

    observer.observe(firstBand);
  },

  // NOTE: This is not a true handler. What is the event? "Border"? This should be named "manageDarkNavbarBorder" or "startScrollMonitor"similar
  handleDarkNavbarBorder() {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        navigation.classList.add("with-border");
      } else {
        navigation.classList.remove("with-border");
      }
    });
  },

  // NOTE: This should be named "handleNavbarLinkLinger" or similar
  handleNavbarLinkOnLinger(e, navbarLink) {
    e.preventDefault();
    e.stopPropagation();

    this.handleExpandDropdownOnLinger(e, navbarLink);
    // NOTE: Why are we executing a wire every time someone lingers on a link? Shouldn't this be done once when the page loads? And because there isn't a corresponding "clear" method, this adds multiple event listeners to the same element every time the user lingers on it.
    this.wireLingerDropdownHandlers(navbarLink);
  },

  handleNavbarMouseleave(e, navbarLink) {
    e.preventDefault();
    e.stopPropagation();

    this.closeDropdownMenu(navbarLink)
  },

  // NOTE: The logic in this method has become unwieldly and is probably ripe for a refactor. I also wonder why Linger links are handled differently than other links. And is it that because they are triggered by Linger events vs. mouseenter or click events? If so, this reason confuses behavioral with semantic differences.
  handleLingerLinkClick(e, navbarLink) {
    e.preventDefault();

    const classList = e.target.classList;

    if (navbarLink.classList.contains('find-flashcards') && !e.target.getAttribute('href') ) {
      return false;
    }

    if (classList.contains('option-link') || classList.contains('browse-option-link') || classList.contains('subject-link')) {

      e.preventDefault();
      e.stopPropagation();

      const newLocation = e.target.getAttribute('href');
      e.target.parentNode.classList.contains('partnerships') ? window.open(newLocation, '_blank') : location = newLocation;

    } else {
      const linkMappings = {
        'find-flashcards': '/subjects',
        'businesses': '/companies',
        'educators': '/teachers',
      };

      // const classList = navbarLink.classList;
      location = linkMappings[Array.from(navbarLink.classList).find(cls => linkMappings.hasOwnProperty(cls))];
    }
  },

  handleLingerLinkMouseleave(e, navbarLink) {
    e.preventDefault();
    e.stopPropagation();

    this.closeDropdownMenu(navbarLink)
  },

  handleOutsideClick(e, elem) {
    if (elem && elem.contains(e.target)) {
      return false;
    }

    this.closeDropdownMenu(elem);
  },

  // NOTE: This is not a true handler. What is the event? "Cta"? This should be named "wireAddTalkToUsCta" or similar
  handleAddTalkToUsCta() {
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        const shouldHide = entry.isIntersecting;
        talkToUsCta.classList.toggle('is-hidden', shouldHide);
      });
    };

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.0 // Trigger when the target is fully hidden
    };

    const observer = new IntersectionObserver(handleIntersection, options);
    const target = document.querySelector('.cms-content .band-1');
    observer.observe(target);
  },

  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

  // All methods in each section of our JS files should be alphabetized.

  closeMobileMenu() {
    navigation.classList.remove('is-open', 'menu');
    this.setBodyPosition();
    navigation.querySelector('.options-container').classList.remove('is-showing');
  },

  openMobileMenu() {
    navigation.classList.add('is-open', 'menu');
    this.setBodyPosition();
    navigation.querySelector('.options-container').classList.add('is-showing');
  },

  clearLingerDropdownHandlers(navbarLink) {
    navbarLink.removeEventListener("mouseleave", (e) => this.handleLingerLinkMouseleave(e, navbarLink));
    navbarLink.removeEventListener("click", (e) => this.handleLingerLinkClick(e, navbarLink));
    navigation.removeEventListener("mouseleave", (e) => this.handleNavbarMouseleave(e, navbarLink));
  },

  closeOtherDropdownMenus(selectedDropdown) {
    let allDropdowns = document.querySelectorAll('.navbar .is-open');

    allDropdowns.forEach((dropdown) => {
      if (dropdown !== selectedDropdown) {
        dropdown.classList.remove('is-open');
      }
    });
  },

  closeDropdownMenu(elem) {
    if (elem) {
      elem.classList.remove('is-open');
      this.stopOutsideClickMonitor(elem);
      this.clearLingerDropdownHandlers(elem);
    }
  },

  isDropdownMenuOpen(elem) {
    return (elem && elem.classList.contains('is-open'));
  },

  openDropdownMenu(elem) {
    if (elem) {
      elem.classList.add('is-open');
      this.startOutsideClickMonitor(elem);
    }
  },

  setBodyPosition() {
    document.body.classList.toggle('mobile-navbar-is-open');
  },

  startOutsideClickMonitor(elem) {
    document.addEventListener('click', (e) => this.handleOutsideClick(e, elem));
  },

  stopOutsideClickMonitor(elem) {
    document.removeEventListener('click', (e) => this.handleOutsideClick(e, elem));
  },

  wireLingerDropdownHandlers(navbarLink) {
    navbarLink.addEventListener("mouseleave", (e) => this.handleLingerLinkMouseleave(e, navbarLink));
    navbarLink.addEventListener("click", (e) => this.handleLingerLinkClick(e, navbarLink));
    navigation.addEventListener("mouseleave", (e) => this.handleNavbarMouseleave(e, navbarLink));
  },
}

export default navbar;
